import { FormattedMessage, useIntl } from "react-intl";

import { evictCache } from "../../../lib/apollo/utils";
import { type CropCycleFields } from "../../../lib/graphql/generated";
import { useCropCycleCreate } from "../../../lib/hooks/agro/cropCycles";
import { useCurrentUser } from "../../../lib/hooks/basic/users";
import { Rules } from "../../form/Form";
import { NewForm } from "../../shared/ListView/NewForm";
import { CropSelect } from "../CropSelect";

export function NewCropCycleForm({ onClose }: { onClose: () => void }) {
  const intl = useIntl();
  const { currentLocalityId } = useCurrentUser();

  return (
    <NewForm
      entityName={intl.formatMessage({ id: "cropCycles.entityName" })}
      mutation={useCropCycleCreate}
      onMutate={(result) => result.cropCycleCreate}
      mutationOptions={{
        refetchQueries: ["Me"],
        update: evictCache("cropCycles"),
      }}
      formValues={() => ({ localityId: currentLocalityId }) as CropCycleFields}
      onClose={onClose}
      fields={[
        {
          name: "name",
          type: "string",
          rules: [Rules.required],
        },
        {
          label: <FormattedMessage id="crops.entityName" />,
          name: "cropIds",
          type: "custom",
          rules: [Rules.required],
          render: () => <CropSelect mode="multiple" />,
        },
        {
          label: <FormattedMessage id="cropCycles.startedAt" />,
          name: "startedAt",
          type: "date",
          rules: [Rules.required],
        },
        {
          label: <FormattedMessage id="cropCycles.estimatedEndDate" />,
          name: "estimatedEndDate",
          type: "date",
          rules: [Rules.required],
        },
      ]}
    />
  );
}
